import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/index.js";
import { useCallback } from "react";
import { closeModal } from "../../../store/features/modal.js";
import { Modal } from "@shopify/polaris";
import { OPEN_MODAL_COLLECTION_CHANGE_CONFIRM_MODAL } from "../../../constants/modalTypes.js";
import { nextStep } from "../../../store/features/action.js";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";

const CollectionChangeConfirmModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType } = useAppSelector((state) => state.modal);

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, []);

  const handleUnderstood = useCallback(() => {
    handleClose();
    dispatch(nextStep());
  }, []);

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_COLLECTION_CHANGE_CONFIRM_MODAL}
      onClose={handleClose}
      title="Warning"
      primaryAction={{
        content: "Understood",
        onAction: handleUnderstood
      }}
      secondaryActions={[{ content: "Cancel", onAction: handleClose }]}
    >
      <Modal.Section>
        <p>
          When pushing down products, the sorting of the collection will automatically change to manual, which means any prior product sorting (such as automated sorting by price or best-sellers) you have set up in your storefront will be overridden.
        </p>
      </Modal.Section>
    </Modal>
  );
};

export default CollectionChangeConfirmModal;